export default import.meta.ROLLDOWN_FILE_URL_5XmuXi2nU8PVp$7eVRd8Nw